(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mars-editable-footer"] && !Shopify.designMode) return;
  try {
    
  class MarsFooterNavigation extends HTMLElement {
    connectedCallback() {
      this.desktop = window.matchMedia('(min-width: 900px)');
      this.menus = Array.from(this.querySelectorAll('details'));
      this.mobileStates = new Map(this.menus.map((menu) => [menu, menu.dataset.openMobile === 'true']));
      this.updateMenus = () => {
        this.menus.forEach((menu) => {
          menu.open = this.desktop.matches || this.mobileStates.get(menu);
          const summary = menu.querySelector('summary');
          if (this.desktop.matches) summary?.setAttribute('tabindex', '-1');
          else summary?.removeAttribute('tabindex');
        });
      };
      this.handleClick = (event) => {
        if (!(event.target instanceof Element)) return;
        const summary = event.target.closest('summary');
        if (!summary || !this.contains(summary)) return;
        const menu = summary.parentElement;
        if (!(menu instanceof HTMLDetailsElement)) return;
        if (this.desktop.matches) event.preventDefault();
        else this.mobileStates.set(menu, !menu.open);
      };
      this.desktop.addEventListener('change', this.updateMenus);
      this.addEventListener('click', this.handleClick);
      this.updateMenus();
    }

    disconnectedCallback() {
      this.desktop.removeEventListener('change', this.updateMenus);
      this.removeEventListener('click', this.handleClick);
    }
  }

  if (!customElements.get('mars-footer-navigation')) {
    customElements.define('mars-footer-navigation', MarsFooterNavigation);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modern-epidemic-story"] && !Shopify.designMode) return;
  try {
    
  class ModernEpidemicMarquee extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('.modern-epidemic__marquee-track');
      const group = track?.firstElementChild;
      if (!(track instanceof HTMLElement) || !(group instanceof HTMLElement)) return;

      const fill = () => {
        const distance = group.getBoundingClientRect().width;
        if (!distance || !group.children.length) return;
        // Keep one complete sequence beyond the viewport at every animation frame.
        const copies = Math.max(2, Math.ceil(this.clientWidth / distance) + 1);
        while (track.children.length > copies) track.lastElementChild?.remove();
        while (track.children.length < copies) {
          const clone = group.cloneNode(true);
          if (!(clone instanceof HTMLElement)) break;
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('id');
          clone.querySelectorAll('[id], [data-shopify-editor-block]').forEach((item) => {
            item.removeAttribute('id');
            item.removeAttribute('data-shopify-editor-block');
          });
          track.append(clone);
        }
        this.style.setProperty('--me-marquee-distance', `${distance}px`);
      };
      this.observer = new ResizeObserver(fill);
      this.observer.observe(this);
      this.observer.observe(group);
      fill();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('modern-epidemic-marquee')) {
    customElements.define('modern-epidemic-marquee', ModernEpidemicMarquee);
  }

  } catch(e) { console.error(e); }
})();
})();
